import { render, staticRenderFns } from "./UserAdminEdit.vue?vue&type=template&id=0d5890d6&"
import script from "./UserAdminEdit.vue?vue&type=script&lang=js&"
export * from "./UserAdminEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5890d6')) {
      api.createRecord('0d5890d6', component.options)
    } else {
      api.reload('0d5890d6', component.options)
    }
    module.hot.accept("./UserAdminEdit.vue?vue&type=template&id=0d5890d6&", function () {
      api.rerender('0d5890d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/UserAdminEdit.vue"
export default component.exports